<template>
  <transition :name="`${ns.namespace.value}-fade-in`">
    <div v-if="visible" :style="backTopStyle" :class="ns.b()" @click.stop="handleClick">
      <slot>
        <z-icon :class="ns.e('icon')"><caret-top /></z-icon>
      </slot>
    </div>
  </transition>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { ZIcon } from '@zoryn/components/icon'
import { CaretTop } from '@zoryn/icons'
import { useNamespace } from '@zoryn/hooks'
import { backtopEmits } from './backtop'
import { useBackTop } from './use-backtop'

import type { BacktopProps } from './backtop'

const COMPONENT_NAME = 'ZBacktop'

defineOptions({
  name: COMPONENT_NAME,
})

const props = withDefaults(defineProps<BacktopProps>(), {
  visibilityHeight: 200,
  target: '',
  right: 40,
  bottom: 40,
})
const emit = defineEmits(backtopEmits)

const ns = useNamespace('backtop')

const { handleClick, visible } = useBackTop(props, emit, COMPONENT_NAME)

const backTopStyle = computed(() => ({
  right: `${props.right}px`,
  bottom: `${props.bottom}px`,
}))
</script>
